import {Injectable} from '@angular/core';
import {AbstractMessageListenerService} from "./abstract-message-listener.service";
import {MatDialog} from "@angular/material/dialog";
import {Player} from "../../backend/model/player.model";
import {
  ReplayHitAfterReportConfirmationDialogComponent,
  ConfirmationDialogData
} from "../game/report/replay-hit-after-report-confirmation-dialog/replay-hit-after-report-confirmation-dialog.component";
import {YesNoDialogData} from "../shared/components/yes-no-dialog/yes-no-dialog.component";

export interface ReportSentMessage {
  player: Player;
  self: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ReportSentMessageService extends AbstractMessageListenerService<ReportSentMessage> {


  constructor(private matDialog: MatDialog) {
    super('reportSent');
  }

  public override process(message: ReportSentMessage): void {
    this.matDialog.open(ReplayHitAfterReportConfirmationDialogComponent, {
      disableClose: true,
      data: {
        titleKey: 'game.report.confirmation.title',
        messageKey: 'game.report.confirmation.message',
        messageData: {player: message.player.name},
        self: message.self
      } as ConfirmationDialogData
    })
  }
}
